// pagehide does not wait for promises. Server-side socket disconnect performs
// recording finalization; this handler only releases local resources.
export function bindRecordingPageLifecycle({ target = window, isBusy, onLeave, onRestore }) {
    let left = false;
    const beforeUnload = event => {
        if (!isBusy()) return;
        event.preventDefault();
        event.returnValue = '';
    };
    const pageHide = () => {
        if (left) return;
        left = true;
        onLeave();
    };
    const pageShow = event => {
        // A restored bfcache document cannot resume a finalized recording.
        if (event.persisted && left) onRestore();
    };
    target.addEventListener('beforeunload', beforeUnload);
    target.addEventListener('pagehide', pageHide);
    target.addEventListener('pageshow', pageShow);
    return () => {
        target.removeEventListener('beforeunload', beforeUnload);
        target.removeEventListener('pagehide', pageHide);
        target.removeEventListener('pageshow', pageShow);
    };
}
